import { Component } from "react";
import { emitter } from "common/emitter";
import moment from "moment";
import Radio from "backbone.radio";

import { nextTick } from "common/utils";

import { security } from "common/components/security";

import { Dialog } from "common/components/dialog/dialog";

class SessionExpire extends Component {
    static defaultProps = {
        onExtend: () => {},
        onCountdownCompleted: () => {}
    }
    
    constructor(props) {
        super(props);
        this.state = {
            time_left: ""
        };
    }
    
    componentDidMount() {
        this.updateFromTokenExpiration();
    }
    
    componentWillUnmount() {
        if (this.#timeout) {
            window.clearTimeout(this.#timeout);
        }
    }
    
    updateFromTokenExpiration = () => {
        const expirationTimestamp = security.getExpiration();
        if (expirationTimestamp <= Date.now()) {
            // Countdown completed to zero
            this.props.onCountdownCompleted();
        } else if (expirationTimestamp > Date.now() + security.timeoutThreshold) {
            // Close the window
            this.props.onExtend();
        } else {
            // Expiring in security.timeoutThreshold or less
            this.setState({
                time_left: moment(expirationTimestamp - Date.now()).format("mm:ss")
            });
            // Schedule another timer
            this.#timeout = window.setTimeout(this.updateFromTokenExpiration, 1000);
        }
    }
    
    #timeout = null
    
    render() {
        return (
            <div className="sessionTimeout">
                <div className="title">Your session will time out in two minutes</div>
                <div className="countdown">{this.state.time_left}</div>
                <div className="info">For security purposes, we automatically sign you out after 15 minutes of inactivity.</div>
                <div className="choice">What would you like to do?</div>
            </div>
        );
    }
}

export const show = function(events) {
    const dialogInstance = new Dialog({
        title: null,
        dismissable: false,
        backdrop: "static",
        onRender(...args) {
            Dialog.prototype.onRender.call(this, ...args);
            nextTick(() => {
                document.getElementById("wrapper").classList.add("blurred");
            });
    
            this.listenTo(Radio.channel("security"), "logoutComplete", this.dismiss);
        },
        onHide() {
            document.getElementById("wrapper").classList.remove("blurred");
        },
        buttons: [{
            role: "default",
            dismiss: true,
            className: "link",
            caption: "Sign out",
            onClick() {
                events.onSignout({ rememberLastUrl: false });
            }
        }, {
            role: "primary",
            dismiss: true,
            caption: "Extend my session",
            onClick() {
                events.onExtend();
            }
        }],
        content: (
            <SessionExpire
                onExtend={() => {
                    dialogInstance.dismiss();
                }}
                onCountdownCompleted={() => {
                    emitter.emit("tracking.track", {
                        type: "automatic_logout"
                    });
                    events.onSignout({ rememberLastUrl: true });
                }}
            />),
        render: true
    });
};
